import { useEffect, useState } from 'react';
import { useCurrentUserStore } from 'store/UserStore';
import { Permission } from 'interfaces';
import { useIsAdmin } from 'hooks/useIsAdmin';

interface CanViewReturn {
  canView: boolean;
}

export const useCanView = (path: string): CanViewReturn => {
  const { role } = useCurrentUserStore();
  const isAdmin = useIsAdmin();
  const [canView, setCanView] = useState<boolean>(false);

  useEffect(() => {
    if (isAdmin) {
      setCanView(true);
    } else {
      const hasViewPermission =
        role?.permissions?.some(
          (permission: Permission) =>
            permission.resource === path && permission.action === 'view'
        ) ?? false;
      setCanView(hasViewPermission);
    }
  }, [isAdmin, path, role]);

  return { canView };
};
